import { AppGrid } from '../components/AppGrid';

export function AppsPage() {
  return (
    <section className="section-page">
      <div className="section-heading">
        <p className="eyebrow">Apps</p>
        <h1>Products from 2xHappiness</h1>
        <p>Browse the apps currently connected to the 2xHappiness website.</p>
      </div>
      <AppGrid />
    </section>
  );
}
